<template>
  <div>
    <Table border ref="selection" :data="dataList" :columns="tableColumns" :disabled-hover="true" :size="tableSize ? tableSize : 'small'"
           @on-row-click="onRowClick" ></Table>
    <div style="margin: 10px;overflow: hidden" v-if="isPage">
      <div style="float: right;">
        <Page :current="curIndex" :total="totalRows" :page-size="pageSize" @on-change="onChangePage" show-sizer
              :page-size-opts="[10,20,50,200,500]" @on-page-size-change="onPageSizeChange" show-total show-elevator/>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: [
      'tableColumns', // 搜索回调
      'asyncFunc', // 请求方法
      'noPage', // 不分页
      'tableSize',
    ],
    data() {
      return {
        dataList: [],
        curIndex: 1, // 当前页
        pageSize: 10,//一页的数量
        totalRows: 0,//数据总条数
      };
    },
    computed: {
      isPage() {
        return this.noPage ? false : true;
      }
    },
    methods: {
      //点击一行时的回调
      onRowClick(data, index) {
        //选中一行
//        this.$refs.selection.toggleSelect(index);
      },
      //点击页码时回调
      onChangePage(index) {
        this.curIndex = index;
        this.asyncFunc(this.curIndex);
      },
      //切换每页条数时的回调
      onPageSizeChange(pageSize) {
        this.pageSize = pageSize;
        this.curIndex = 1;
        this.asyncFunc(this.curIndex);
      },
      // 获取pageSize
      getPageSize() {
        return this.pageSize
      },
      // 刷新界面
      refresh() {
        this.asyncFunc(this.curIndex);
      },
      getSelection() {
        return this.$refs.selection ? this.$refs.selection.getSelection() : [];
      },
      success({index, totalRows, dataList}) {
        this.curIndex = index ? index : 1;
        this.totalRows = totalRows ? totalRows : 0;
        this.dataList = dataList ? dataList : [];
        if (index > 1 && dataList.length == 0) {
          this.asyncFunc(this.curIndex - 1);
        }
      }
    },
    mounted() {
    }
  };
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/BasicTable/index.vue